import Link from 'next/link'
import 'swiper/css/bundle'
import React from 'react'

// import required modules
import { IMG_PLACEHOLDER } from '@components/utils/textVariables'
import classNames from 'classnames'
import {
  getCurrentPage,
  getImageNameFromURL,
  sanitizeData,
} from '@framework/utils/app-util'
import { generateUri } from '@commerce/utils/uri-util'
import IntersectionObserverComponent, {
  IBannerData,
} from '@components/utils/IntersectionObserverComponent'
import { useUI } from '@components/ui'
import { EmptyGuid } from '@components/utils/constants'
import { GA_EVENT } from 'hooks/ga_event.modal'
import { recordGA4Event } from '@components/services/analytics/ga4'
import useSection from 'hooks/useSection'

const CategoryColumPanelData = ({
  data,
  columnCount,
  mobileRowCount,
  deviceInfo,
  showPadding,
}: any) => {
  const { isMobile, isIPadorTablet, isOnlyMobile } = deviceInfo
  const { user } = useUI()
  const { handleSection } = useSection()
  //    const [paddingTop, setPaddingTop] = useState('0');
  const css = { maxWidth: '100%', height: 'auto' }
  const handleBannerClick = (bannerData: IBannerData) => {
    const currentPage = getCurrentPage()
    if (currentPage) {
      recordGA4Event(window, GA_EVENT.BANNER_CLICK, {
        ...bannerData,
        current_page: currentPage,
        loggedin_status: !!(user?.userId && user?.userId !== EmptyGuid),
      })
    }

    const headingData = data[columnCount + 'columnheading']
    let title = ''
    if (headingData?.length) {
      title = headingData[0][columnCount + 'columnheading_title']
    }

    if (bannerData && title == 'Offer Zone') {
      handleSection(title)
    }
  }
  return (
    <>
      {data && data[columnCount + 'columndata']?.length > 0 && (
        <div className={`${showPadding ? 'py-3' : ''}`}>
          <div className="flex flex-col px-0 sm:px-4">
            <div
              className={`mob-align-grid-top grid grid-cols-${mobileRowCount} sm:grid-cols-${columnCount} ${
                showPadding ? 'gap-px' : ''
              }`}
            >
              {data &&
                data[columnCount + 'columndata'] &&
                data[columnCount + 'columndata']?.length &&
                sanitizeData(data[columnCount + 'columndata'])?.map(
                  (cate: any, categoryidx: number) => {
                    let title = ''
                    const headingData = data[columnCount + 'columnheading']
                    if (headingData?.length) {
                      title =
                        headingData[0][columnCount + 'columnheading_title']
                    }
                    const image = cate[columnCount + 'columndata_heroimage']
                    const bannerData: IBannerData = {
                      position:
                        data[columnCount + 'columndata']?.length == 1
                          ? 0
                          : categoryidx + 1,
                      banner_name: image ? getImageNameFromURL(image) : '',
                      component_type: 'image',
                      component_name: columnCount + 'columndata',
                      url: image ?? '',
                    }
                    return (
                      <>
                        <IntersectionObserverComponent
                          title={title}
                          eventName={GA_EVENT.BANNER_IMPRESSIONS}
                          bannerData={bannerData}
                        >
                          {(cate[columnCount + 'columndata_heroimage'] != '' ||
                            cate[columnCount + 'columndata_mobileheroimage'] !=
                              '') && (
                            <div
                              onClick={() => {
                                handleBannerClick(bannerData)
                              }}
                              className="relative flex flex-col w-full rounded"
                              key={`${categoryidx}-category-key-${columnCount}`}
                            >
                              {(cate[columnCount + 'columndata_heroimage'] !=
                                '' ||
                                cate[
                                  columnCount + 'columndata_mobileheroimage'
                                ] != '') && (
                                <div
                                  className={classNames(
                                    cate[columnCount + 'columndata_title'] != ''
                                      ? `image-overlay`
                                      : `no-overlay-img`
                                  )}
                                >
                                  <Link
                                    legacyBehavior
                                    href={
                                      cate[columnCount + 'columndata_link'] ||
                                      '/'
                                    }
                                    passHref
                                  >
                                    <a className="cursor-pointer">
                                      {isMobile || isIPadorTablet ? (
                                        <>
                                          {cate[
                                            columnCount +
                                              'columndata_mobileheroimage'
                                          ] != '' ? (
                                            <img
                                              src={
                                                cate[
                                                  columnCount +
                                                    'columndata_mobileheroimage'
                                                ] || IMG_PLACEHOLDER
                                              }
                                              alt={
                                                cate[
                                                  columnCount +
                                                    'columndata_title'
                                                ] || 'home banner'
                                              }
                                              style={css}
                                              // width={2000}
                                              // height={500}
                                              className={`image w-full category-image-count-${columnCount}`}
                                            />
                                          ) : (
                                            <img
                                              src={
                                                cate[
                                                  columnCount +
                                                    'columndata_heroimage'
                                                ] || IMG_PLACEHOLDER
                                              }
                                              alt={
                                                cate[
                                                  columnCount +
                                                    'columndata_title'
                                                ] || 'home banner'
                                              }
                                              style={css}
                                              // width={2000}
                                              // height={500}
                                              className={`image w-full category-image-count-${columnCount}`}
                                            />
                                          )}
                                        </>
                                      ) : (
                                        <img
                                          src={
                                            cate[
                                              columnCount +
                                                'columndata_heroimage'
                                            ] || IMG_PLACEHOLDER
                                          }
                                          alt={
                                            cate[
                                              columnCount + 'columndata_title'
                                            ] || 'home banner'
                                          }
                                          style={css}
                                          // width={2000}
                                          // height={500}
                                          className={`image w-full category-image-count-${columnCount}`}
                                        />
                                      )}

                                      {/* DESKTOP VIEW */}
                                      <div className="absolute z-10 flex-col hidden gap-2 text-left sm:flex left-2 bottom-4">
                                        {cate[
                                          columnCount + 'columndata_buttontitle'
                                        ] != '' ? (
                                          <Link
                                            legacyBehavior
                                            href={
                                              cate[
                                                columnCount + 'columndata_link'
                                              ]
                                            }
                                            passHref
                                          >
                                            <span className="pb-0.1 text-sm font-semibold text-left text-white truncate text-ellipsis w-44 overflow-hidden">
                                              {
                                                cate[
                                                  columnCount +
                                                    'columndata_buttontitle'
                                                ]
                                              }
                                            </span>
                                          </Link>
                                        ) : (
                                          <></>
                                        )}
                                        {cate[
                                          columnCount + 'columndata_title'
                                        ] != '' && (
                                          <Link
                                            legacyBehavior
                                            href={
                                              cate[
                                                columnCount + 'columndata_link'
                                              ] || '/'
                                            }
                                            passHref
                                          >
                                            <span className="pb-0.1 text-xs font-semibold text-left text-white">
                                              {
                                                cate[
                                                  columnCount +
                                                    'columndata_title'
                                                ]
                                              }
                                            </span>
                                          </Link>
                                        )}
                                        {cate[
                                          columnCount + 'columndata_description'
                                        ] != '' && (
                                          <div
                                            className="px-0 py-0 text-xs font-light text-white description "
                                            dangerouslySetInnerHTML={{
                                              __html:
                                                cate[
                                                  columnCount +
                                                    'columndata_description'
                                                ],
                                            }}
                                          ></div>
                                        )}
                                      </div>
                                      <div className="absolute left-auto right-auto z-10 flex flex-col w-full gap-2 leading-3 text-center sm:hidden bottom-2">
                                        {cate[
                                          columnCount + 'columndata_buttontitle'
                                        ] != '' ? (
                                          <Link
                                            legacyBehavior
                                            href={
                                              cate[
                                                columnCount + 'columndata_link'
                                              ]
                                            }
                                            passHref
                                          >
                                            <span className="pb-0.1 text-sm font-semibold text-center text-white truncate text-ellipsis w-full sm:w-full lg:w-44 overflow-hidden">
                                              {
                                                cate[
                                                  columnCount +
                                                    'columndata_buttontitle'
                                                ]
                                              }
                                            </span>
                                          </Link>
                                        ) : (
                                          <Link
                                            legacyBehavior
                                            href={
                                              cate[
                                                columnCount + 'columndata_link'
                                              ] || '/'
                                            }
                                            passHref
                                          >
                                            <span>
                                              <span className="pb-0.1 text-xxxs font-semibold text-left text-white">
                                                {
                                                  cate[
                                                    columnCount +
                                                      'columndata_title'
                                                  ]
                                                }
                                              </span>
                                            </span>
                                          </Link>
                                        )}
                                      </div>
                                    </a>
                                  </Link>
                                </div>
                              )}
                              {cate[columnCount + 'columndata_tag'] != '' && (
                                <div className="absolute left-0 z-10 flex-1 top-1 sm:top-1 lg:top-3 sm:flex">
                                  <label className="px-1 py-1 font-normal text-white bg-orange-500 sm:px-2 sm:text-xs text-badge-small">
                                    {cate[columnCount + 'columndata_tag']}
                                  </label>
                                </div>
                              )}
                              {!isOnlyMobile && (
                                <div
                                  className={classNames(
                                    cate[
                                      columnCount + 'columndata_buttontitle'
                                    ] != ''
                                      ? `flex mt-1 mb-2 flex-col w-full px-1 leading-3 text-left sm:hidden text-${columnCount}-center`
                                      : `flex flex-col w-full px-1 leading-3 text-left sm:hidden text-${columnCount}-center`
                                  )}
                                >
                                  {cate[
                                    columnCount + 'columndata_buttontitle'
                                  ] != '' ? (
                                    <Link
                                      legacyBehavior
                                      href={
                                        cate[columnCount + 'columndata_link'] ||
                                        '/'
                                      }
                                      passHref
                                    >
                                      <span className="pb-0.1 text-xxxs font-semibold text-left text-black cursor-pointer">
                                        {cate[columnCount + 'columndata_title']}
                                      </span>
                                    </Link>
                                  ) : (
                                    <></>
                                  )}
                                  {(cate[
                                    columnCount + 'columndata_description'
                                  ] != '' ||
                                    cate[
                                      columnCount + 'columndata_description'
                                    ] != '<p><br></p>') && (
                                    <div
                                      className="px-0 py-0 mt-2 overflow-hidden text-xs font-light text-black text-clip-2"
                                      dangerouslySetInnerHTML={{
                                        __html:
                                          cate[
                                            columnCount +
                                              'columndata_description'
                                          ],
                                      }}
                                    />
                                  )}
                                </div>
                              )}
                            </div>
                          )}
                        </IntersectionObserverComponent>
                      </>
                    )
                  }
                )}
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default CategoryColumPanelData
